// removed by extract-text-webpack-plugin
module.exports = {"container":"container__QLA9C","header":"header__1X8Zl","collapser":"collapser__2kmOi","title":"title__36OKj","intro":"intro__EK9fA","hero":"hero__ITbL3","info":"info__1OKKD","infoCollapser":"infoCollapser__2Fkwx","subheader":"subheader__3R5BQ","subtitle":"subtitle__3tFWF","description":"description__DkktH","metadatas":"metadatas__OrduD","metadata":"metadata__1EOCQ","metadataTitle":"metadataTitle__23VAD","metadataItems":"metadataItems__QdZ2j","metadataItem":"metadataItem__McnOj","next":"next__3Xwm-","nextContent":"nextContent__2OrZL","nextHeader":"nextHeader__2Rgb_","nextLink":"nextLink__2lj3U"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Project/styles.scss
// module id = 261
// module chunks = 0